export const HTTP_INTERCEPTORS_HEADER_CHANGED_ID = 'interceptorHeaderInfo.changed';
export let interceptorHeaderInfo = {value:{"x-client-app": "dcs-cloud-front"}};
export let headerMap = {
    skfx_token: "X-Skfx-Token",
    username: "X-Username",
    exp: "X-Exp",
    skfx_session: "X-Sfkx-Session",
    ksh_token: "X-Ksh-Token",
    stereo_map: "X-Stereo-Map",
    sessionId: "X-Session-Id",
    data_path: "X-Data-Path",
    qxbzb: "X-Qxbzb",
    lang: "X-Lang",
    zone: "Zone"
}